export default '/src/assets/webgl/pedro_1/audios/en/bundle_1.mp3'